var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.cruise != null
    ? _c("div", [
        _c("div", { staticClass: "dashboard-main-content" }, [
          _c("div", { staticClass: "container-fluid" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-lg-12" }, [
                _c("form", { attrs: { id: "cruiseDetailBigForm" } }, [
                  _c("div", { staticClass: "form-box" }, [
                    _c("div", { staticClass: "form-content pb-2" }, [
                      _c(
                        "div",
                        { staticClass: "row justify-content-between" },
                        [
                          _c("div", { staticClass: "col-lg-6" }, [
                            _c("div", { staticClass: "card-item p-3" }, [
                              _c(
                                "div",
                                { staticClass: "contact-form-action" },
                                [
                                  _c("h3", { staticClass: "title mb-3" }, [
                                    _vm._v("Cruise"),
                                  ]),
                                  _vm._v(" "),
                                  _c("base-edit-input", {
                                    attrs: {
                                      rules: "required",
                                      type: "text",
                                      label: "Adı",
                                    },
                                    model: {
                                      value: _vm.cruise.name,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.cruise, "name", $$v)
                                      },
                                      expression: "cruise.name",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("base-text-area-input", {
                                    attrs: {
                                      rules: "required",
                                      label: "Açıklama",
                                    },
                                    model: {
                                      value: _vm.cruise.description,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.cruise, "description", $$v)
                                      },
                                      expression: "cruise.description",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-lg-6" }, [
                            _c("div", { staticClass: "card-item p-3" }, [
                              _c(
                                "div",
                                { staticClass: "contact-form-action" },
                                [
                                  _c("h3", { staticClass: "title mb-3" }, [
                                    _vm._v("İstatistik"),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "row" }, [
                                    _c(
                                      "div",
                                      { staticClass: "col-md-6" },
                                      [
                                        _c("base-edit-input", {
                                          attrs: {
                                            rules: "required|min_value:1",
                                            type: "number",
                                            label: "Yaş",
                                          },
                                          model: {
                                            value:
                                              _vm.cruise.statistics.ageOfShip,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.cruise.statistics,
                                                "ageOfShip",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "cruise.statistics.ageOfShip",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-md-6" },
                                      [
                                        _c("base-edit-input", {
                                          attrs: {
                                            rules: "required|min_value:1",
                                            type: "number",
                                            label: "Tonaj",
                                          },
                                          model: {
                                            value:
                                              _vm.cruise.statistics.tonnage,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.cruise.statistics,
                                                "tonnage",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "cruise.statistics.tonnage",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-md-6" },
                                      [
                                        _c("base-edit-input", {
                                          attrs: {
                                            rules: "required|min_value:1",
                                            type: "number",
                                            label: "Uzunluk",
                                          },
                                          model: {
                                            value: _vm.cruise.statistics.length,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.cruise.statistics,
                                                "length",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "cruise.statistics.length",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-md-6" },
                                      [
                                        _c("base-edit-input", {
                                          attrs: {
                                            rules: "required|min_value:1",
                                            type: "number",
                                            label: "Genişlik",
                                          },
                                          model: {
                                            value: _vm.cruise.statistics.beam,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.cruise.statistics,
                                                "beam",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "cruise.statistics.beam",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-md-6" },
                                      [
                                        _c("base-edit-input", {
                                          attrs: {
                                            rules: "required|min_value:1",
                                            type: "number",
                                            label: "Hız",
                                          },
                                          model: {
                                            value: _vm.cruise.statistics.speed,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.cruise.statistics,
                                                "speed",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "cruise.statistics.speed",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-md-6" },
                                      [
                                        _c("base-edit-input", {
                                          attrs: {
                                            rules: "required|min_value:1",
                                            type: "number",
                                            label: "Yolcu Kapasitesi",
                                          },
                                          model: {
                                            value:
                                              _vm.cruise.statistics
                                                .guestCapacity,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.cruise.statistics,
                                                "guestCapacity",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "cruise.statistics.guestCapacity",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-md-6" },
                                      [
                                        _c("base-edit-input", {
                                          attrs: {
                                            rules: "required|min_value:1",
                                            type: "number",
                                            label: "Toplam Mürettebat",
                                          },
                                          model: {
                                            value:
                                              _vm.cruise.statistics.totalStaff,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.cruise.statistics,
                                                "totalStaff",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "cruise.statistics.totalStaff",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]),
                                ]
                              ),
                            ]),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "btn-box" }, [
                        _vm.cruise.id == null
                          ? _c(
                              "button",
                              {
                                staticClass: "theme-btn",
                                class: { disabled: !_vm.formValid },
                                attrs: { type: "button" },
                                on: { click: _vm.create },
                              },
                              [_vm._v("Kaydet")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.cruise.id != null
                          ? _c(
                              "button",
                              {
                                staticClass: "theme-btn",
                                class: { disabled: !_vm.formValid },
                                attrs: { type: "button" },
                                on: { click: _vm.update },
                              },
                              [_vm._v("Güncelle")]
                            )
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "section-block mb-4" }),
                      _vm._v(" "),
                      _vm.cruise.id != null
                        ? _c("div", { staticClass: "row" }, [
                            _c(
                              "div",
                              { staticClass: "col-lg-12" },
                              [_c("deck-list")],
                              1
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "section-block mb-4" }),
                      _vm._v(" "),
                      _vm.cruise.id != null
                        ? _c("div", { staticClass: "row" }, [
                            _c(
                              "div",
                              { staticClass: "col-lg-12" },
                              [_c("room-list")],
                              1
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "section-block mb-4" }),
                      _vm._v(" "),
                      _vm.cruise.id != null
                        ? _c("div", { staticClass: "row" }, [
                            _c(
                              "div",
                              { staticClass: "col-lg-12" },
                              [_c("cruise-room-list")],
                              1
                            ),
                          ])
                        : _vm._e(),
                    ]),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          [
            _c("deck-detail"),
            _vm._v(" "),
            _c("cruise-room-detail"),
            _vm._v(" "),
            _c("room-detail"),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }